import type { CSSProperties } from "react";

// Shared by every `*Administration.tsx` tab wrapper (Feedback, History, Ideas, Users).
// Establishes a bounded flex chain from AdminLayout down to each table's own
// scrollable region - see AdminLayout.tsx for why this needs to stay a real height,
// not "auto". Non-table tabs (Insights, Analytics) rely on ADMIN_TAB_CONTENT_STYLE's
// overflow: "auto" as their scroll fallback since they don't self-constrain like the
// tables do.
export const ADMIN_TAB_ROOT_STYLE: CSSProperties = { height: "100%" };

export const ADMIN_TAB_CONTENT_STYLE: CSSProperties = {
    flex: 1,
    minHeight: 0,
    display: "flex",
    flexDirection: "column",
    overflow: "auto"
};
